export default class DesignTeamUsersUpdate {
  constructor(opts) {
    if (opts.ids_match == "true") {
      $(opts.row).html($(opts.msg))
    } else {
      $(opts.row).slideUp();
    }
    $(opts.form).slideUp();
  }
}
